(function () {
  'use strict';

  window.WGSRefurb = window.WGSRefurb || {};

  class WGSRefurbTabs extends HTMLElement {
    connectedCallback() {
      this.initTabs();
    }

    initTabs() {
      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));

      this.tabs.forEach((tab) => {
        if (tab._onTabClick) {
          tab.removeEventListener('click', tab._onTabClick);
        }
        tab._onTabClick = () => this.activate(tab);
        tab.addEventListener('click', tab._onTabClick);
      });

      const selected =
        this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') ||
        this.tabs[0];

      if (selected) this.activate(selected, false);
    }

    activate(activeTab, focus = false) {
      if (!activeTab) return;
      this.tabs.forEach((tab) => {
        const active = tab === activeTab;
        const panelId = tab.getAttribute('aria-controls');
        const panel = panelId ? document.getElementById(panelId) : null;

        tab.setAttribute('aria-selected', active ? 'true' : 'false');
        tab.setAttribute('tabindex', active ? '0' : '-1');

        if (panel) {
          if (active) {
            panel.removeAttribute('hidden');
            panel.style.display = 'block';
          } else {
            panel.setAttribute('hidden', '');
            panel.style.display = 'none';
          }
        }
      });

      if (focus) activeTab.focus();
    }
  }

  if (!customElements.get('wgs-refurb-tabs')) {
    customElements.define('wgs-refurb-tabs', WGSRefurbTabs);
  }

  // 监听 Shopify 后台 Theme Editor 实时同步
  document.addEventListener('shopify:section:load', (event) => {
    const tabs = event.target.querySelectorAll('wgs-refurb-tabs');
    tabs.forEach((tab) => tab.initTabs());
  });

  document.addEventListener('shopify:block:select', (event) => {
    const blockId = event.detail.blockId;
    const tab = document.querySelector(`[aria-controls*="${blockId}"]`);
    if (tab) {
      const tabComp = tab.closest('wgs-refurb-tabs');
      if (tabComp) tabComp.activate(tab, true);
    }
  });

  // 加购与锚点滚动
  async function addToCart(button) {
    if (button.disabled) return;
    const variantId = button.dataset.wgsVariantId;
    if (!variantId) return;

    const originalText = button.textContent.trim();
    button.disabled = true;
    button.textContent = 'Adding…';

    try {
      const response = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variantId), quantity: 1 }] })
      });

      const result = await response.json();
      if (!response.ok || result.status) throw new Error(result.description || 'Failed');

      button.textContent = 'Added';
      document.dispatchEvent(new CustomEvent('wgs:cart-updated', { bubbles: true, detail: result }));
      
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && typeof cartDrawer.open === 'function') cartDrawer.open();
    } catch (err) {
      console.error(err);
      button.textContent = 'Try Again';
    } finally {
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
      }, 1500);
    }
  }

  document.addEventListener('click', (event) => {
    const addButton = event.target.closest('[data-wgs-add-to-cart]');
    if (addButton) {
      event.preventDefault();
      addToCart(addButton);
      return;
    }

    const anchor = event.target.closest('[data-wgs-scroll]');
    if (anchor) {
      const target = document.querySelector(anchor.dataset.wgsScroll);
      if (target) {
        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
  });
})();